export const CONTROL_LOCAL_BROWSER_SKILL_NAME = 'control-local-browser';
export function isControlLocalBrowserSkillName(skillName) {
    return skillName.trim().toLowerCase() === CONTROL_LOCAL_BROWSER_SKILL_NAME;
}
export function buildControlLocalBrowserSkillQuery({ localizedName, query, }) {
    const skillUrl = `/computer/skills?skillId=${CONTROL_LOCAL_BROWSER_SKILL_NAME}`;
    const skillMarkdown = `[${localizedName}](${skillUrl})`;
    return `${query} ${skillMarkdown}`;
}
//# sourceMappingURL=controlLocalBrowserSkill.js.map